import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
} from '@mui/material';
import type { TableProps as MuiTableProps } from '@mui/material/Table';
import type { TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody';
import type { TableCellProps as MuiTableCellProps } from '@mui/material/TableCell';
import type { TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead';
import type { TableRowProps as MuiTableRowProps } from '@mui/material/TableRow';

export type TableProps = MuiTableProps;
export type TableBodyProps = MuiTableBodyProps;
export type TableCellProps = MuiTableCellProps;
export type TableHeadProps = MuiTableHeadProps;
export type TableRowProps = MuiTableRowProps;

export const Table = ({ sx, ...rest }: TableProps): JSX.Element => {
  const baseSx: MuiTableProps['sx'] = { tableLayout: 'fixed', width: '100%' };
  const resolvedSx = sx ? [baseSx, ...(Array.isArray(sx) ? sx : [sx])] : baseSx;
  return <MuiTable sx={resolvedSx} {...rest} />;
};
export const TableBody = ({ ...rest }: TableBodyProps): JSX.Element => <MuiTableBody {...rest} />;
export const TableCell = ({ ...rest }: TableCellProps): JSX.Element => <MuiTableCell {...rest} />;
export const TableHead = ({ ...rest }: TableHeadProps): JSX.Element => <MuiTableHead {...rest} />;
export const TableRow = ({ ...rest }: TableRowProps): JSX.Element => <MuiTableRow {...rest} />;
